var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "homeheader"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "containers"
  }, [_c('div', {
    staticClass: "top",
    class: {
      'topbar-scroll-bg': _vm.leaveTop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHeader,
      expression: "showHeader"
    }],
    staticClass: "container top"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": _vm.getHeaderLink('/')
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('首页');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "right-header menu",
    on: {
      "click": function click($event) {
        return _vm.changeMenu(false);
      }
    }
  }), _vm._v(" "), _vm.islogined ? _c('div', {
    staticClass: "login_info right-header"
  }, [_c('span', {
    staticClass: "face",
    style: _vm.userFace,
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "nickname",
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      }
    }
  }, [_vm._v(_vm._s(_vm.userInfo && _vm.userInfo.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "logout",
    class: {
      none: _vm.logoutDisplay
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      },
      "click": function click($event) {
        return _vm.logoutAction();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("logOut")))])]) : _c('div', {
    staticClass: "logwrap right-header"
  }, [_c('a', {
    staticClass: "login logwrap_login",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doLogin();
      }
    }
  }, [_vm._v(_vm._s("".concat(_vm.$t("signIn"), " / ").concat(_vm.$t('userSign.signUp'))))])]), _vm._v(" "), _c('a', {
    staticClass: "recharge_wrap right-header"
  }, [_c('span', {
    staticClass: "recharge_txt"
  }, [_vm._v(_vm._s(_vm.$t("wallet")))]), _vm._v(" "), _c('div', {
    staticClass: "recharge_list"
  }, [_c('a', {
    staticClass: "convert",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doConvert();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("convertToCoins")))]), _vm._v(" "), _c('a', {
    staticClass: "cash",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doCashOut();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cashOut")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top toprelative"
  }), _vm._v(" "), _c('right-menu', {
    attrs: {
      "closeState": _vm.closeState,
      "changeMenu": _vm.changeMenu
    }
  }), _vm._v(" "), _c('loginReg', {
    ref: "logReg",
    attrs: {
      "success": _vm.successHandle,
      "logout": _vm.logoutHandle
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };